import ApiService from './ApiService';

class SecurityCompanyService {
  async getSecurityCompanyList() {
    try {
      const response = await ApiService.call('/secured/get_security_company_list', 'POST');
      let data = response;

      return {
        securityCompanyList: data.result,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async createSecurityCompany(payload) {
    try {
      const response = await ApiService.call(
        '/secured/create_security_company',
        'POST',
        payload,
      );

      console.log(response);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new SecurityCompanyService();
